var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluseLitlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 1.33317C6.6665 0.964981 6.36803 0.666504 5.99984 0.666504C5.63165 0.666504 5.33317 0.964981 5.33317 1.33317V5.33317H1.33317C0.964981 5.33317 0.666504 5.63165 0.666504 5.99984C0.666504 6.36803 0.964981 6.6665 1.33317 6.6665H5.33317V10.6665C5.33317 11.0347 5.63165 11.3332 5.99984 11.3332C6.36803 11.3332 6.6665 11.0347 6.6665 10.6665V6.6665H10.6665C11.0347 6.6665 11.3332 6.36803 11.3332 5.99984C11.3332 5.63165 11.0347 5.33317 10.6665 5.33317H6.6665V1.33317Z",
    fill: "#131111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluseLitlIcon);
export default __webpack_public_path__ + "static/media/pluse-litl-icon.73cdccd6dc324c5accc4a4fbea5b899d.svg";
export { ForwardRef as ReactComponent };